import styled from "styled-components";

const ListItemGroup = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export default ListItemGroup;
